import request from '../../utils/request';
import { fileService } from "@/api/common/file-utils";
export default {
    checkIsRepeat: (data) => {
        return request({
            url: `/feedbacks/checkIsRepeat`,
            method: 'post',
            data: data
        })
    },
    list: (data) => {
        return request({
            url: '/feedbacks',
            method: 'post',
            data: data
        })
    },
    getDetail: (data) => {
        return request({
            url: `/feedbacks/init`,
            method: 'post',
            data: data
        })
    },
    saveFeedbackInfo: (data) => {
        return request({
            url: `/feedbacks/save`,
            method: 'post',
            data: data
        })
    },
    saveFeedbackInfoMCD: (data) => {
        return request({
            url: `/feedbacks/mcdSave`,
            method: 'post',
            data: data
        })
    },
    feedBackCenterReturn: (data) => {
        return request({
            url: `/feedbacks/fcReturn`,
            method: 'post',
            data: data
        })
    },
    saveFeedBackSourceCode: (data) => {
        return request({
            url: `/feedbacks/updateSourceCode`,
            method: 'post',
            data: data
        })
    },
    getStoreInfo: (data) => {
        return request({
            url: `/feedbacks/store/` + data,
            method: 'get'
        })
    },
    getMaterialInfo: (data, params) => {
        return request({
            url: `/feedbacks/material/` + data,
            method: 'get',
            params: params
        })
    },
    suspendFeedBack: (id, val) => {
        console.log("GY🚀 ~ val:", val);
        return request({
            url: `/feedbacks/suspend/` + id,
            method: 'post',
            data: val
        })
    },
    copyFeedBack: (data) => {
        return request({
            url: `/feedbacks/copy/`,
            method: 'post',
            data: data
        })
    },
    exportFeedbackList: (param) => request({
        url: 'feedbacks/export',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, '问题报告.xls');
    }),
    checkRepeat: (data) => {
        return request({
            url: `/feedbacks/checkRepeat`,
            method: 'post',
            data: data
        })
    },
    saveFcRemarks: (data) => {
        return request({
            url: `/feedbacks/updateFcRemarks`,
            method: 'post',
            data: data
        })
    },
}